import { useQuery } from '@tanstack/react-query';
import { useHasRole } from '@/hooks/useSession';
import { getTransmitterPopulate } from '../api';
import { transmittersKeys } from './useTransmitters';

/**
 * Fetch transmitter + dropdown options via V2 populate endpoint.
 * Automatically picks admin vs non-admin path based on user role.
 */
export function useTransmitterPopulate(
  transmitterId: string | null,
  deviceType: 'transmitters' | 'gateways' = 'transmitters',
) {
  const isAdmin = useHasRole('full_admin');

  return useQuery({
    // isAdmin and deviceType are part of the key so responses are cached separately
    queryKey: [...transmittersKeys.populate(transmitterId ?? '', isAdmin), deviceType],
    queryFn: () => getTransmitterPopulate(transmitterId!, isAdmin, deviceType),
    enabled: !!transmitterId,
    staleTime: 30 * 1000,
  });
}
